/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import FloatingLabelInput from "../../../Components/floatingLabel/FloatingLabel";
import "../../EmployeeScreens/EmployeeProfile/EMPProfile.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Apiurl, GetToken } from "../../../Utils/utils";
import axios from "axios";
import moment from "moment";
import Loader from "../../../Components/loader/loader";
import { toast } from "react-toastify";
import { useProfile } from "../../../Context/ProfileContext";

const AdminProfile = () => {
  const { profileData, fetchProfile } = useProfile();

  const [errorFirstName, setErrorFirstName] = useState(false);
  const [errorLastName, setErrorLastName] = useState(false);
  const [dummy, setDummy] = useState(false);
  const [errorEmergencyContactNumber, setErrorEmergencyContactNumber] =
    useState(false);
  const [errorMobile, setErrorMobile] = useState(false);
  const [errorAddress, setErrorAddress] = useState(false);
  const [errorMaritalStatus, setErrorMaritalStatus] = useState(false);

  const [newImageUrl, setNewImageUrl] = useState("");
  const [photoExtension, setPhotoExtension] = useState("");
  const fileInputRef = useRef(null);
  const adhaarFileInputRef = useRef(null);

  const [showSidebar, setShowSidebar] = useState(true);
  const [ProfileData, setProfileData] = useState("");
  const [loading, setLoading] = useState(false);

  const [profileImageFile, setProfileImageFile] = useState(null);
  const [adhaarImageFiles, setAdhaarImageFiles] = useState([]);
  const [aadhaarPreviewFiles, setAadhaarPreviewFiles] = useState([]);
  const LoginToken = GetToken();

  const [profileAlldata, setProfileAllData] = useState({
    FirstName: "",
    LastName: "",
    Email: "",
    Mobile: "",
    Gender: "",
    MaritalStatus: "",
    DateOfBirth: "",
    Department: "",
    Designation: "",
    Address: "",
    UrlLink: "",
    AdhaarLink: "",
    Emergencycontactno: "",
    TeamLeads: "",
  });

  const Gender = [
    { value: "Male", label: "Male", id: 0 },
    { value: "Female", label: "Female", id: 1 },
    { value: "Transgender", label: "Transgender", id: 2 },
  ];

  const MaritalStatusOptions = [
    { value: "Single", label: "Single", id: 0 },
    { value: "Married", label: "Married", id: 1 },
    { value: "Divorced", label: "Divorced", id: 2 },
    { value: "Widowed", label: "Widowed", id: 3 },
  ];

  const allowedAdhaarTypes = [
    "application/pdf",
    "image/jpeg",
    "image/jpg",
    "image/png",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const getFileExtension = (fileName = "") => {
    return fileName.split(".").pop()?.toLowerCase() || "";
  };

  const isImageFile = (file) => {
    if (!file) return false;
    return file.type?.startsWith("image/");
  };

  const isPdfFile = (file) => {
    if (!file) return false;
    return file.type === "application/pdf";
  };

  const normalizeExistingAadhaarFiles = (aadharValue) => {
    if (!aadharValue) return [];

    if (Array.isArray(aadharValue)) {
      return aadharValue
        .filter(Boolean)
        .map((item, index) => ({
          id: `existing-${index}`,
          name: `Aadhaar ${index + 1}`,
          preview: typeof item === "string" ? item : item?.url || "",
          type: "existing",
          isExisting: true,
          isImage:
            typeof item === "string"
              ? /\.(jpg|jpeg|png|gif|webp)$/i.test(item) ||
                item.startsWith("data:image")
              : true,
          isPdf:
            typeof item === "string"
              ? /\.pdf$/i.test(item) || item.startsWith("data:application/pdf")
              : false,
        }));
    }

    if (typeof aadharValue === "string") {
      const trimmed = aadharValue.trim();

      if (!trimmed) return [];

      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
          return normalizeExistingAadhaarFiles(parsed);
        }
      } catch (err) {}

      const separatedValues = trimmed
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item && !item.startsWith("base64"));

      if (
        separatedValues.length > 1 &&
        !trimmed.startsWith("data:") &&
        !trimmed.startsWith("http")
      ) {
        return separatedValues.map((item, index) => ({
          id: `existing-${index}`,
          name: `Aadhaar ${index + 1}`,
          preview: item,
          type: "existing",
          isExisting: true,
          isImage:
            /\.(jpg|jpeg|png|gif|webp)$/i.test(item) ||
            item.startsWith("data:image"),
          isPdf:
            /\.pdf$/i.test(item) || item.startsWith("data:application/pdf"),
        }));
      }

      return [
        {
          id: "existing-0",
          name: "Existing Aadhaar",
          preview: trimmed,
          type: "existing",
          isExisting: true,
          isImage:
            /\.(jpg|jpeg|png|gif|webp)$/i.test(trimmed) ||
            trimmed.startsWith("data:image"),
          isPdf:
            /\.pdf$/i.test(trimmed) || trimmed.startsWith("data:application/pdf"),
        },
      ];
    }

    return [];
  };

  const validate = () => {
    if (!profileAlldata?.FirstName) {
      setErrorFirstName("userFirstName");
      return false;
    }
    if (!profileAlldata?.Mobile) {
      setErrorMobile("userMobile");
      return false;
    }
    if (!profileAlldata?.Emergencycontactno) {
      setErrorEmergencyContactNumber("userEmergencyContactNumber");
      return false;
    }
    if (!profileAlldata?.Address) {
      setErrorAddress("userAddress");
      return false;
    }
    return true;
  };

  useEffect(() => {
    setProfileData((prevProfileData) => ({
      ...prevProfileData,
      Mobile: prevProfileData?.Mobile || "",
      Gender: prevProfileData?.Gender || "",
      DateOfBirth: prevProfileData?.DateOfBirth || "",
      Department: prevProfileData?.Department || "",
    }));
  }, []);

  useEffect(() => {
    if (profileData) {
      const gender = Gender?.find((e) => e?.id === profileData?.Gender);
      const maritalStatus = MaritalStatusOptions?.find(
        (e) => e?.id === profileData?.MaritalStatus
      );

      setProfileData(profileData);

      setProfileAllData({
        FirstName: profileData?.FirstName || "",
        LastName: profileData?.LastName || "",
        Email: profileData?.Email || "",
        Mobile: profileData?.Mobile?.slice(0, 10) || "",
        DateOfBirth: profileData?.DateOfBirth || "",
        Gender: gender || "",
        Department: profileData?.Departments?.Name || "",
        Designation: profileData?.Designations?.DesignationName || "",
        Address: profileData?.Address || "",
        UrlLink: profileData?.UrlLink || "",
        Emergencycontactno: profileData?.Emergencycontactno || "",
        TeamLeads: profileData?.TeamLeads?.UserName || "",
        MaritalStatus: maritalStatus || "",
        AdhaarLink: profileData?.AadharCard || "",
      });

      const existingAadhaarFiles = normalizeExistingAadhaarFiles(
        profileData?.AadharCard
      );
      setAadhaarPreviewFiles(existingAadhaarFiles);
    }
  }, [profileData]);

  useEffect(() => {
    return () => {
      aadhaarPreviewFiles.forEach((item) => {
        if (!item?.isExisting && item?.preview) {
          URL.revokeObjectURL(item.preview);
        }
      });
    };
  }, [aadhaarPreviewFiles]);

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64Image = reader.result;
      setProfileAllData((prev) => ({
        ...prev,
        UrlLink: base64Image,
      }));
      setNewImageUrl(base64Image);
    };
    reader.readAsDataURL(file);

    const extension = file.type?.split("/")?.[1] || "";
    setPhotoExtension(extension);
    setProfileImageFile(file);
  };

  const handleAdhaarChange = (e) => {
    const selectedFiles = Array.from(e.target.files || []);
    if (!selectedFiles.length) return;

    const validFiles = [];
    for (let i = 0; i < selectedFiles.length; i += 1) {
      const file = selectedFiles[i];
      const isValidType =
        allowedAdhaarTypes.includes(file.type) ||
        ["pdf", "jpg", "jpeg", "png", "doc", "docx"].includes(
          getFileExtension(file.name)
        );

      if (!isValidType) {
        toast.error(`Unsupported file type: ${file.name}`);
        continue;
      }

      validFiles.push(file);
    }

    if (!validFiles.length) {
      e.target.value = "";
      return;
    }

    const totalFilesCount = adhaarImageFiles.length + validFiles.length;
    if (totalFilesCount > 2) {
      toast.error("Maximum 2 files allowed for Aadhaar upload");
      e.target.value = "";
      return;
    }

    const newPreviewFiles = validFiles.map((file, index) => ({
      id: `${file.name}-${Date.now()}-${index}`,
      name: file.name,
      file,
      preview: isImageFile(file) ? URL.createObjectURL(file) : "",
      type: file.type,
      isExisting: false,
      isImage: isImageFile(file),
      isPdf: isPdfFile(file),
    }));

    setAdhaarImageFiles((prev) => [...prev, ...validFiles]);
    setAadhaarPreviewFiles((prev) => [...prev, ...newPreviewFiles]);

    e.target.value = "";
  };

  const handleRemoveAadhaarFile = (itemToRemove) => {
    if (!itemToRemove) return;

    if (!itemToRemove.isExisting && itemToRemove.preview) {
      URL.revokeObjectURL(itemToRemove.preview);
    }

    setAadhaarPreviewFiles((prev) =>
      prev.filter((item) => item.id !== itemToRemove.id)
    );

    if (!itemToRemove.isExisting) {
      setAdhaarImageFiles((prev) =>
        prev.filter(
          (file) =>
            !(
              file.name === itemToRemove.name &&
              file.size === itemToRemove.file?.size &&
              file.lastModified === itemToRemove.file?.lastModified
            )
        )
      );
    }
  };

  const handleUpdateProfile = (clicked) => {
    if (!validate()) return;

    setLoading(true);

    const formData = new FormData();
    formData.append("Id", ProfileData?.Id || "");
    formData.append("FirstName", profileAlldata?.FirstName || "");
    formData.append("LastName", profileAlldata?.LastName || "");
    formData.append("Gender", profileAlldata?.Gender?.id ?? "");
    formData.append("Mobile", profileAlldata?.Mobile || "");
    formData.append("Address", profileAlldata?.Address || "");
    formData.append("DateOfBirth", profileAlldata?.DateOfBirth || "");
    formData.append("PhotoExtenssion", photoExtension || "");
    formData.append(
      "Emergencycontactno",
      profileAlldata?.Emergencycontactno || ""
    );

    if (profileAlldata?.MaritalStatus?.id !== undefined) {
      formData.append("MaritalStatus", profileAlldata?.MaritalStatus?.id);
    }

    if (profileAlldata?.UrlLink && profileAlldata?.UrlLink.startsWith("data:")) {
      const base64Photo = profileAlldata?.UrlLink?.split("base64,")?.[1] || "";
      if (base64Photo) {
        formData.append("Photo", base64Photo);
      }
    }

    if (adhaarImageFiles.length > 0) {
      adhaarImageFiles.forEach((file) => {
        formData.append("AadharFiles", file);
      });
    }

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Profile/UpdateProfile`,
      data: formData,
    };

    axios(option)
      .then((res) => {
        setLoading(false);

        if (clicked === "update") {
          setDummy(true);
        }

        if (res?.status === 200) {
          toast.success(res?.data?.message || "Profile updated successfully");
          setProfileImageFile(null);
          setAdhaarImageFiles([]);
          if (adhaarFileInputRef.current) adhaarFileInputRef.current.value = "";
          if (fileInputRef.current) fileInputRef.current.value = "";
          setTimeout(() => fetchProfile(), 500);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(
          error?.response?.data?.message || "Failed to update profile"
        );
      });
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}

      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />

      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} dummy={dummy} setDummy={setDummy} />

        <section
          className={
            showSidebar
              ? "EMP-profile-main-section"
              : "EMP-profile-main-section-new"
          }
        >
          <div className="EMP-profile-all-icons">
            <div>
              <p className="MAIN-HEADING">Profile</p>
            </div>
            <div className="dashboiard-inner-header">
              <BiHomeAlt className="EMP-home-icon-header-inn" />
              <MdKeyboardArrowRight />
              <p>Profile</p>
              <MdKeyboardArrowRight />
              <p>Profile</p>
            </div>
          </div>

          <div className="EMP-profile-main-container">
            <div className="EMP-profile-outter-container">
              <div className="EMP-profile-inner-container">
                <div className="EMP-profile-heading">
                  <p>Profile</p>
                </div>

                <div className="EMP-profile-inner-box row">
                  <div className="profile-inputs col-6">
                    <FloatingLabelInput
                      label="FirstName*"
                      value={profileAlldata.FirstName || ""}
                      onChange={(e) =>
                        setProfileAllData({
                          ...profileAlldata,
                          FirstName: e?.target?.value,
                        })
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorFirstName("userFirstName");
                        } else {
                          setErrorFirstName("false");
                        }
                      }}
                    />
                    {errorFirstName === "userFirstName" &&
                    !profileAlldata?.FirstName ? (
                      <span className="contact_error-dob">
                        First name is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="profile-inputs col-6">
                    <FloatingLabelInput
                      label="LastName"
                      value={profileAlldata?.LastName || ""}
                      onChange={(e) =>
                        setProfileAllData({
                          ...profileAlldata,
                          LastName: e?.target?.value,
                        })
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorLastName("userLastName");
                        } else {
                          setErrorLastName("false");
                        }
                      }}
                    />
                    {errorLastName === "userLastName" &&
                    !profileAlldata?.LastName ? (
                      <span className="contact_error-dob">
                        Last name is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="profile-inputs-disabled col-6">
                    <FloatingLabelInput
                      label="Email*"
                      value={profileAlldata?.Email?.trim() || ""}
                      onChange={(e) =>
                        setProfileAllData({
                          ...profileAlldata,
                          Email: e?.target?.value,
                        })
                      }
                      style={{ marginBottom: 0 }}
                      disabled
                    />
                  </div>

                  <div className="profile-inputs-disabled col-6">
                    <FloatingLabelInput
                      label="Gender*"
                      value={profileAlldata.Gender?.label || ""}
                      onChange={(e) =>
                        setProfileAllData({
                          ...profileAlldata,
                          Gender: e?.target?.value,
                        })
                      }
                      disabled
                    />
                  </div>

                  <div className="profile-inputs col-6">
                    <FloatingLabelInput
                      label="Mobile*"
                      maxLength="10"
                      value={profileAlldata.Mobile || ""}
                      onChange={(e) => {
                        const inputMobile = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                        setProfileAllData({
                          ...profileAlldata,
                          Mobile: inputMobile,
                        });
                      }}
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorMobile("userMobile");
                        } else {
                          setErrorMobile("false");
                        }
                      }}
                    />
                    {errorMobile === "userMobile" && !profileAlldata?.Mobile ? (
                      <span className="contact_error-dob">
                        Mobile no is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="profile-inputs col-6">
                    <FloatingLabelInput
                      label="Emergency Contact*"
                      maxLength="10"
                      value={profileAlldata?.Emergencycontactno || ""}
                      onChange={(e) => {
                        const inputMobile = e?.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                        setProfileAllData({
                          ...profileAlldata,
                          Emergencycontactno: inputMobile,
                        });
                      }}
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorEmergencyContactNumber(
                            "userEmergencyContactNumber"
                          );
                        } else {
                          setErrorEmergencyContactNumber("false");
                        }
                      }}
                    />
                    {errorEmergencyContactNumber ===
                      "userEmergencyContactNumber" &&
                    !profileAlldata?.Emergencycontactno ? (
                      <span className="contact_error-dob">
                        Emergency contact no is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="profile-inputs col-6">
                    <label>Date Of Birth</label>
                    <input
                      type="date"
                      value={
                        profileAlldata?.DateOfBirth
                          ? moment(profileAlldata?.DateOfBirth).format(
                              "YYYY-MM-DD"
                            )
                          : ""
                      }
                      onChange={(e) => {
                        const formattedDate = moment(e?.target?.value).format(
                          "DD MMMM YYYY"
                        );
                        setProfileAllData({
                          ...profileAlldata,
                          DateOfBirth: formattedDate,
                        });
                      }}
                    />
                  </div>

                  <div className="profile-inputs col-6">
                    <label className="label-manaegement-section">
                      Marital Status
                    </label>
                    <select
                      className="profile-select-input"
                      value={profileAlldata?.MaritalStatus?.id ?? ""}
                      onChange={(e) => {
                        const selectedStatus = MaritalStatusOptions.find(
                          (status) => status.id === parseInt(e.target.value, 10)
                        );
                        setProfileAllData({
                          ...profileAlldata,
                          MaritalStatus: selectedStatus,
                        });
                      }}
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorMaritalStatus("userMaritalStatus");
                        } else {
                          setErrorMaritalStatus("false");
                        }
                      }}
                    >
                      <option value="">Select Marital Status</option>
                      {MaritalStatusOptions.map((status) => (
                        <option key={status.id} value={status.id}>
                          {status.label}
                        </option>
                      ))}
                    </select>
                    {errorMaritalStatus === "userMaritalStatus" &&
                    !profileAlldata?.MaritalStatus ? (
                      <span className="contact_error-dob">
                        Marital Status is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="profile-inputs-for-image col-6">
                    <label htmlFor="profileImage">Profile Image</label>
                    <div className="profile-inputs-for-image-inner-div profile-upload-row">
                      <input
                        type="file"
                        id="profileImage"
                        ref={fileInputRef}
                        onChange={handleImageChange}
                        accept="image/*"
                      />

                      <label htmlFor="profileImage" className="custom-file-btn">
                        Choose File
                      </label>

                      <div className="image-preview-right-box">
                        {newImageUrl ? (
                          <img
                            className="image-of-profile"
                            src={newImageUrl}
                            alt="Profile"
                          />
                        ) : profileAlldata?.UrlLink ? (
                          <img
                            className="image-of-profile"
                            src={profileAlldata?.UrlLink}
                            alt="Profile"
                          />
                        ) : (
                          <span className="upload-placeholder-text">
                            No image selected
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="profile-inputs-for-image col-6">
                    <label htmlFor="adhaarImage">
                      Aadhaar Upload (Maximum 2 files)
                    </label>

                    <div className="profile-inputs-for-image-inner-div adhaar-upload-wrapper">
                      <div className="profile-upload-row">
                        <input
                          type="file"
                          id="adhaarImage"
                          ref={adhaarFileInputRef}
                          onChange={handleAdhaarChange}
                          multiple
                          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                        />

                        <label htmlFor="adhaarImage" className="custom-file-btn">
                          Choose Files
                        </label>

                        <span className="aadhaar-file-limit-text">
                          {aadhaarPreviewFiles.length}/2 files selected
                        </span>
                      </div>

                      <div className="adhaar-preview-grid">
                        {aadhaarPreviewFiles.length > 0 ? (
                          aadhaarPreviewFiles.map((item) => (
                            <div className="adhaar-preview-card" key={item.id}>
                              <button
                                type="button"
                                className="remove-file-btn"
                                onClick={() => handleRemoveAadhaarFile(item)}
                              >
                                ×
                              </button>

                              {item.isImage ? (
                                <img
                                  src={item.preview}
                                  alt={item.name}
                                  className="adhaar-preview-image"
                                />
                              ) : item.isPdf ? (
                                <div className="adhaar-preview-fallback">
                                  PDF
                                </div>
                              ) : (
                                <div className="adhaar-preview-fallback">
                                  DOC
                                </div>
                              )}

                              <div className="adhaar-preview-name">
                                {item.name}
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="aadhaar-empty-box">
                            Click “Choose Files” to upload Aadhaar front/back
                            image or document
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {profileAlldata.Department ? (
                    <div className="profile-inputs-disabled col-4">
                      <FloatingLabelInput
                        label="Department*"
                        value={profileAlldata.Department}
                        onChange={(e) =>
                          setProfileAllData({
                            ...profileAlldata,
                            Department: e?.target?.value,
                          })
                        }
                        disabled
                      />
                    </div>
                  ) : null}

                  {profileAlldata?.Designation ? (
                    <div className="profile-inputs-disabled col-4">
                      <FloatingLabelInput
                        label="Designation*"
                        value={profileAlldata?.Designation}
                        onChange={(e) =>
                          setProfileAllData({
                            ...profileAlldata,
                            Designation: e?.target?.value,
                          })
                        }
                        disabled
                      />
                    </div>
                  ) : null}

                  {profileAlldata?.TeamLeads ? (
                    <div className="profile-inputs-disabled col-4">
                      <FloatingLabelInput
                        label="Team Lead*"
                        value={profileAlldata?.TeamLeads}
                        onChange={(e) =>
                          setProfileAllData({
                            ...profileAlldata,
                            TeamLeads: e?.target?.value,
                          })
                        }
                        disabled
                      />
                    </div>
                  ) : null}

                  <div className="profile-text-area col-md-12">
                    <label>Address</label>
                    <textarea
                      cols="30"
                      rows="8"
                      value={profileAlldata.Address}
                      onChange={(e) =>
                        setProfileAllData({
                          ...profileAlldata,
                          Address: e?.target?.value,
                        })
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorAddress("userAddress");
                        } else {
                          setErrorAddress("false");
                        }
                      }}
                    />
                    {errorAddress === "userAddress" &&
                    !profileAlldata?.Address ? (
                      <span className="contact_error-dob">
                        Address is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="Addemployee-buttons">
                    <button
                      className="Profile-submit-button"
                      onClick={() => handleUpdateProfile("update")}
                    >
                      {profileAlldata ? "Update" : "Submit"}
                    </button>
                    <button className="Profile-Cancel-button">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AdminProfile;